/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
import { _ as __assign } from '../../../tslib.es6-e01eabb2.js';

// https://page.cainiao.com/cn-yz/cnyz-book/_book/api/share.html?spm=a2d5h.23431112.0.0
function showSharePanel(options, context) {
    var formatInput = function (input) {
        var _a;
        var cnStation = ((_a = input === null || input === void 0 ? void 0 : input._ext) !== null && _a !== void 0 ? _a : {}).cnStation;
        return __assign({ type: 'url' }, cnStation);
    };
    context.WVCall('TBSharedModule.showSharedMenu', options, {
        formatInput: formatInput,
    });
}

export { showSharePanel as default };
